export default __webpack_public_path__ + "static/media/CLYNK_Green_2500x.6092a5bc.png";